import { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = 'Le nom est requis';
    if (!formData.email.trim()) newErrors.email = 'L\'email est requis';
    if (!formData.phone.trim()) newErrors.phone = 'Le téléphone est requis';
    if (!formData.subject.trim()) newErrors.subject = 'Le sujet est requis';
    if (!formData.message.trim()) newErrors.message = 'Le message est requis';

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    }, 2000);
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border rounded-lg shadow-md max-w-md mx-auto">
      <div className="mb-4">
        <label className="block mb-1">Nom</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full p-2 border rounded" />
        {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
      </div>
      
      <div className="mb-4">
        <label className="block mb-1">Email</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border rounded" />
        {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
      </div>
      
      <div className="mb-4">
        <label className="block mb-1">Téléphone</label>
        <input type="text" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border rounded" />
        {errors.phone && <p className="text-red-500 text-sm">{errors.phone}</p>}
      </div>
      
      <div className="mb-4">
        <label className="block mb-1">Sujet</label>
        <input type="text" name="subject" value={formData.subject} onChange={handleChange} className="w-full p-2 border rounded" />
        {errors.subject && <p className="text-red-500 text-sm">{errors.subject}</p>}
      </div>
      
      <div className="mb-4">
        <label className="block mb-1">Message</label>
        <textarea name="message" value={formData.message} onChange={handleChange} className="w-full p-2 border rounded" rows="4"></textarea>
        {errors.message && <p className="text-red-500 text-sm">{errors.message}</p>}
      </div>
      
      <motion.button 
        type="submit" 
        disabled={isSubmitting} 
        className="w-full bg-blue-500 text-white p-2 rounded flex items-center justify-center"
        whileTap={{ scale: 0.95 }}>
        {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
        <Send className="ml-2" size={16} />
      </motion.button>
      
      {isSubmitted && (
        <div className="mt-4 p-2 text-green-600 border border-green-500 rounded flex items-center">
          <CheckCircle className="mr-2" /> Message envoyé avec succès !
        </div>
      )}
    </form>
  );
};

export default ContactForm;
